import {connect} from "react-redux";
import {readFeature, onConnectionEvent, disconnect, startDisconnectNotification, startErrorNotification, startWriteNotification, startBatteryNotification, startTelemetryNotification, notifyError} from "../actions/misc";
import Dashboard from "../components/Dashboard/Dashboard";

const mapStateToProps = ({misc}) => {
  return ({
    connected: misc.connected.reading,
    name: misc.name.reading.name,
    modelnum: misc.modelnum.reading,
    firmware: misc.firmware.reading.firmware,
    notification: misc.notification,
    batteryLevel: misc.battery.reading.status,
    batteryRemoteLevel: misc.batteryRemote.reading.status,
  });
};

const mapDispatchToProps = (dispatch) => ({
  onConnectionEvent: (state) => {
    dispatch(onConnectionEvent(state));
  },
  readName: () => {
    dispatch(readFeature("name"));
  },
  readModelNum: () => {
    dispatch(readFeature("modelnum"));
  },
  readFirmware: () => {
    dispatch(readFeature("firmware"));
  },
  disconnect: () => {
    dispatch(disconnect());
  },
  startDisconnectNotification: () => {
    dispatch(startDisconnectNotification());
  },
  startErrorNotification: () => {
    dispatch(startErrorNotification());
  },
  startWriteNotification: () => {
    dispatch(startWriteNotification());
  },
  startBatteryNotification: () => {
    dispatch(startBatteryNotification("battery", "on"));
  },
  startTelemetryNotification: () => {
    dispatch(startTelemetryNotification("telemetry", "on"));
  },
  notifyError: (e) => {
    dispatch(notifyError(e));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Dashboard);
